module.exports = __webpack_public_path__ + "img/gnzs12.9231608b.png";